import React from 'react';
import { Sparkles, BookOpen, Video, Smartphone, Clock, DollarSign, Home } from 'lucide-react';
export function BenefitsAndIncludes() {
  const benefits = [{
    title: 'Cero Frustración',
    desc: 'Aprenderás la mezcla exacta para evitar grietas y burbujas.'
  }, {
    title: 'Rápido y Fácil',
    desc: 'Técnicas simplificadas para que veas resultados en tu primer fin de semana.'
  }, {
    title: 'Terapia Creativa',
    desc: 'Desconecta del estrés diario mientras creas con tus propias manos.'
  }, {
    title: 'Oportunidad de Negocio',
    desc: 'Crea piezas de alto valor percibido con un costo de material bajísimo.'
  }];
  const includes = [{
    icon: Video,
    text: 'Crear piezas únicas para tu hogar',
    subtitle: 'Portavelas, macetas, lámparas, jaboneras y piezas en tendencia.'
  }, {
    icon: BookOpen,
    text: 'Guía de proporciones y materiales en PDF'
  }, {
    icon: Clock,
    text: 'Acceso inmediato y de por vida'
  }, {
    icon: Smartphone,
    text: 'Estudia desde tu celular, tablet o PC'
  }, {
    icon: Home,
    text: 'Decorá casas con piezas hechas por vos',
    subtitle: 'Sin experiencia previa.'
  }, {
    icon: DollarSign,
    text: 'Vender tus piezas y recuperar tu inversión',
    subtitle: 'El cemento decorativo es furor en 2026. Muchas alumnas venden sus primeras piezas antes de terminar el curso.'
  }];
  return <section className="py-24 bg-sage-900 text-sand-50 relative overflow-hidden" data-id="element-15">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1618220179428-22790b46a0eb?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-16"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-17">
        <div className="max-w-5xl mx-auto" data-id="element-18">
          <div className="text-center mb-16" data-id="element-19">
            <span className="text-gold-400 text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-20">
              Transformación
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold mb-6 text-white" data-id="element-21">
              ¿Qué lograrás con este programa?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-24" data-id="element-22">
            {benefits.map((benefit, idx) => <div key={idx} className="bg-sage-800/50 backdrop-blur-sm p-8 md:p-10 rounded-3xl border border-sage-700 hover:border-gold-500/30 transition-colors group" data-id="element-23">
                <Sparkles className="w-6 h-6 text-gold-400 mb-5 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-24" />
                <h3 className="text-xl font-heading font-semibold mb-3 text-white" data-id="element-25">
                  {benefit.title}
                </h3>
                <p className="text-sage-200 font-light leading-relaxed" data-id="element-26">
                  {benefit.desc}
                </p>
              </div>)}
          </div>

          <div className="bg-sand-50 text-concrete-900 rounded-[2.5rem] p-8 md:p-16 shadow-premium relative" data-id="element-27">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-terracotta-500 text-white px-6 py-2 rounded-full text-xs font-bold tracking-widest uppercase shadow-lg" data-id="element-28">
              El Programa Incluye
            </div>

            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-center mb-12 mt-4" data-id="element-29">
              Todo lo que necesitas para empezar
            </h2>

            <div className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-30">
              {includes.map((item, idx) => <div key={idx} className="flex items-start gap-5 p-5 bg-white rounded-2xl border border-sand-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-31">
                  <div className="bg-sand-100 p-3 rounded-xl text-terracotta-500 flex-shrink-0" data-id="element-32">
                    <item.icon className="w-5 h-5" data-id="element-33" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-34">
                    <p className="font-medium text-concrete-700 text-sm md:text-base leading-snug" data-id="element-35">
                      {item.text}
                    </p>
                    {'subtitle' in item && item.subtitle && <p className="text-xs md:text-sm text-concrete-500 font-light leading-relaxed mt-1.5" data-id="element-36">
                        {item.subtitle}
                      </p>}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}